import {
  RugbyUnionEventStatusId,
  RugbyUnionIncidentId,
  RugbyUnionResultId,
} from '@collector/sportsapi-client-legacy'

import { PitchPenaltyOverlayConfig } from '../../../configuration'

export const pitchPenaltyOverlayConfig: PitchPenaltyOverlayConfig<
  RugbyUnionEventStatusId,
  RugbyUnionResultId,
  RugbyUnionIncidentId
> = {
  penaltyStatusId: RugbyUnionEventStatusId.Penalties,
  penaltyResultId: RugbyUnionResultId.Penalty,
  scoredPenaltyIncidentId: RugbyUnionIncidentId.PenaltyKickGoal,
  missedPenaltyIncidentId: RugbyUnionIncidentId.PenaltyKickMissed,
}
